import Vue from 'vue'
import VueRouter from 'vue-router'
import { Dialog } from 'vant';

Vue.use(VueRouter)

const routes = [
  
  {
    path:'/',
    redirect:'/home'
    // redirect:'/test'
    // redirect:'/loginTest'
  },
  // 图片
  {
    path: '/pic',
    name: 'pic',
    component: () => import( '../components/pic.vue')
  },
   // 测试
  //  {
  //   path: '/test',
  //   name: 'Test',
  //   component: () => import( '../views/tabTest.vue')
  // },
  {
    path: '/test',
    name: 'Test',
    component: () => import( '../views/tabTest.vue'),
    meta:{
      title:'百度一下'
    }
  },
  // 首页
  {
    path: '/home',
    name: 'Home',
    component: () => import( '../views/Home.vue')
  },
  // 信息填写页
  {
    path: '/certMessage',
    name: 'certMessage',
    component: () => import( '../views/certMessage.vue')
  },
  // 管理员登录
  {
    path:'/managerLogin',
    name:'managerLogin',
    component: () => import( '../views/manager/login.vue')
  },
   // 管理员首页
   {
    path:'/manager',
    name:'manager',
    component: () => import( '../views/manager/index.vue')
  },
   // 数据统计
   {
    path:'/dataCount',
    name:'dataCount',
    component: () => import( '../views/manager/dataCount.vue')
  },
   // 数据查询
   {
    path:'/dataQuery',
    name:'dataQuery',
    component: () => import( '../views/manager/dataQuery.vue')
  },
   // 白名单
   {
    path:'/whiteList',
    name:'whiteList',
    component: () => import( '../components/user/whiteList.vue')
  },
  // 用户管理
  {
    path:'/user',
    name:'user',
    component: () => import( '../views/manager/user.vue')
  },
   // 用户管理
  // {
  //   path:'/manageUser',
  //   name:'manageUser',
  //   component: () => import( '../components/user/manage.vue')
  // },
   // 服务站用户管理
  //  {
  //   path:'/serveManageUser',
  //   name:'serveManageUser',
  //   component: () => import( '../components/user/serveManage.vue')
  // },
  // 取牌申请状态查询
  {
    path: '/applyState',
    name: 'applyState',
    component: () => import( '../views/applyState.vue')
  },
  // 服务站信息
  {
    path: '/station',
    name: 'station',
    component: () => import( '../views/stationDic.vue')
  },
  // 服务站首页
  {
    path: '/stationIndex',
    name: 'stationIndex',
    component: () => import( '../views/manager/stationIndex.vue')
  },
  // 服务站取牌确认
  {
    path: '/getPlate',
    name: 'getPlate',
    component: () => import( '../components/station/getPlate.vue')
  },
  // 服务站查询历史记录
  {
    path: '/queryHistory',
    name: 'history',
    component: () => import( '../components/station/history.vue')
  },
  {
    // 二维码
    path: '/qrcode',
    name: 'qrcode',
    component: () => import('../views/QRCode/index.vue'),
  },
  {
    // 登录测试
    path: '/loginTest',
    name: 'loginTest',
    component: () => import('../views/loginTest.vue'),
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to,from,next)=>{
  if(to.path === '/home'||to.path === '/managerLogin' || to.path === '/certMessage'){
    next()
  }else{
    let token = localStorage.getItem('Authorization')
    if(token === 'null' || token === ''){
      // next('/managerLogin')
      Dialog.alert({
        title:'提示',
        message:'登录已过期，请重新的登录。点击确认跳转到登录页面'
      }).then(() => {
        // 用户点击确认后，跳转到登录页面
        next('/managerLogin')
      })
    }else {
      next()
    }
  }
})
  // let intervalId
  // router.beforeEach((to,from,next) => {
  //   // 每次路由跳转之前执行的逻辑
  //   clearInterval(intervalId)//清除之前可能存在的定时器
  //   intervalId = setInterval(() => {
  //     // 每秒钟检查一次 sessionStorage 中的 token 是否存在
  //     const tokenStr = localStorage.getItem('Authorization')
  //     if(!tokenStr && (to.path !== '/home'|| to.path !== '/managerLogin' || to.path !== '/certMessage')){
  //       // token 不存在且 当前页不是首页、登录页、填写信息页，执行以下逻辑
  //       clearInterval(intervalId)//清除定时器，避免重复弹窗
  //       Dialog.alert({
  //         title:'提示',
  //         message:'登录已过期，请重新的登录。点击确认跳转到登录页面'
  //       }).then(() => {
  //         // 用户点击确认后，跳转到登录页面
  //         next('/managerLogin')
  //       })
  //     }
  //   },1000)//每秒检查一次
  //   // 继续路由导航
  //   next()
  // })
export default router
